import { axios } from "lib/axios";
import queryString from "query-string";

export const verifyAccount = data => {
  return axios.post(`/auth/verify_otp?${queryString.stringify(data)}`);
};
